import React, {useState, useEffect, useRef} from 'react';
import Button from '../../../components/button/Button';
import Header from '../../../components/header/Header';
import {ReactComponent as MingcuteTransferLine} from '../../../assets/icons/transfer/mingcuteTransferLine.svg';
import {ReactComponent as Btc} from '../../../assets/icons/transfer/btc.svg';
import {ReactComponent as Eth} from '../../../assets/icons/transfer/eth.svg';
import {ReactComponent as Tether} from '../../../assets/icons/transfer/tether.svg';
import {ReactComponent as DollarIco} from "../../../assets/icons/transfer/dollarIco.svg";
import axios from 'axios';
import {ReactComponent as LoginCross} from "../../../assets/icons/transfer/marketClose.svg";
import {closeSnackbar, enqueueSnackbar} from 'notistack';
import './Transfer.css';
import {useTranslation} from "react-i18next";


const Transfer = () => {
    const {t} = useTranslation();
    const actionSnackbar = snackbarId => (
        <button className="close-button" onClick={() => closeSnackbar(snackbarId)}>
            <LoginCross/>
        </button>
    );

    (function () {
        function decimalAdjust(type, value, exp) {
            if (typeof exp === 'undefined' || +exp === 0) {
                return Math[type](value);
            }
            value = +value;
            exp = +exp;
            if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
                return NaN;
            }
            value = value.toString().split('e');
            value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
            value = value.toString().split('e');
            return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
        }

        if (!Math.floor10) {
            Math.floor10 = function (value, exp) {
                return decimalAdjust('floor', value, exp);
            };
        }
    })();
    const selectRef = useRef(null);
    const [valueFrom, setValueFrom] = useState('');
    const [valueTo, setValueTo] = useState('');
    const [accountFrom, setAccountFrom] = useState('main');
    const [accountTo, setAccountTo] = useState('futures');
    const [coin, setCoin] = useState('usdt');
    const [balance, setBalance] = useState({});
    const [balanceFrom, setBalanceFrom] = useState(0);
    const [balanceTo, setBalanceTo] = useState(0);
    const token = localStorage.getItem('token');

    const [balanceFutures, setBalanceFutures] = useState("")
    const [balanceInvest, setBalanceInvest] = useState("")
    const [balanceMain, setBalanceMain] = useState("")

    const returnIcon = (courseName) => {
        if (courseName === 'btc') {
            return <Btc/>;
        } else if (courseName === 'eth') {
            return <Eth/>;
        } else {
            return <Tether/>;
        }
    };

    const fetchBalance = (account, dest) => {
        console.log(account);
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance${account === "main" ? "" : `/${account}`}`, {
            headers: {Authorization: `Bearer ${token}`},
        })
            .then((res) => {
            console.log(res.data)
                if(account == "invest") {
                    setBalanceInvest(Math.floor10(res.data["usd"], -6))
                    console.log(res.data, coin, account)
                }
                if(account == "main") {
                    if(accountFrom == "main" && accountTo == "invest"){
                        setBalanceMain(Math.floor10(res.data['usdt'], -6))
                    }
                    else {
                        setBalanceMain(res.data[coin].toFixed(10).replace(/\.?0+$/,''))
                        // setBalanceMain(Math.floor10(res.data[coin], -6))
                    }
                    console.log(res.data, coin, account)
                    console.log(Math.floor10(res.data[coin], -6))
                }
                if(account == "futures") {
                    setBalanceFutures(Math.floor10(res.data["usdt"], -6))
                    console.log(res.data, coin, account)
                }

                setBalance(res.data);
            });
            // .then((res) => {
            //     if (dest === "to") {
            //         setBalanceTo(Math.floor10(res.data[coin], -6));
            //     } else if (dest === "from") {
            //         setBalanceFrom(Math.floor10(res.data[coin], -6));
            //     }
            //     setBalance(res.data);
            // });
    };

    const getBalances = () =>{
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance/main/common`, {headers: {"Authorization" : `Bearer ${token}`}})
            .then(res => {
                setBalanceMain(Math.floor10(res.data, -2))
            })
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance/futures/common`, {headers: {"Authorization" : `Bearer ${token}`}})
            .then(res => {
                setBalanceFutures(Math.floor10(res.data, -2))
            })
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance/invest/common`, {headers: {"Authorization" : `Bearer ${token}`}})
            .then(res => {
                setBalanceInvest(Math.floor10(res.data, -2))
            })
    }

    

    // useEffect(() => {
    //     getBalances()
    // }, [])

    useEffect(() => {
        if (accountFrom != "futures" && accountFrom != "main"){
            setCoin("usdt")
        }
        if (accountFrom == 'invest'){
            setCoin("usdt")
        }
        // getBalances()
        fetchBalance(accountFrom, "from");
        fetchBalance(accountTo, "to");
    }, [accountFrom, accountTo, coin]);

    const handleValueChange = (e) => {
        setValueTo(e.target.value);
        setValueFrom(e.target.value);
    };

    const handleWalletConvertation = () => {
        let [coinFrom, coinTo, balanceFrom, balanceTo] = [coin, coin, accountFrom, accountTo];
        console.log(balanceFrom, ">", balanceTo)
        console.log("balanceFrom",balanceFrom, "\n", "balanceTo", balanceTo)
        if (Number(balanceFrom) > Number(balanceTo)) {
            enqueueSnackbar(t("transfer.noMoney"), {
                action: actionSnackbar,
                autoHideDuration: 3000, variant: 'error',
                className: "snackerror"
            });
        } else {
            if (balanceTo === "futures" && coinFrom !== "usd") {
                axios({
                    method: "post",
                    url: "https://api-ru.fynex.cc/api/api/convert",
                    data: {
                        type: "main",
                        valueFrom:valueTo,
                        valueTo,
                        coinFrom,
                        coinTo,
                        balanceFrom,
                        balanceTo
                    },
                    headers: {"Authorization": `Bearer ${token}`}
                })
                    .then(res => {
                        setValueFrom(0);
                        fetchBalance(accountFrom, "from");
                        fetchBalance(accountTo, "to");
                        enqueueSnackbar(t("transfer.success"), {action: actionSnackbar, autoHideDuration: 3000, variant: 'success'});
                    })
                    .catch(error => {
                        error.response.data.detail.forEach(errormsg => {
                            enqueueSnackbar(`${t("transfer.err")}: ${errormsg.msg}`, {
                                action: actionSnackbar,
                                autoHideDuration: 3000, variant: 'error'
                            });
                        });
                    });
            } else if (balanceTo === "invest" && coinFrom !== "usd") {
                console.log(balanceTo === "invest" && coinFrom !== "usd", "1 IF!~!!!!!");
                
                axios({
                    method: "post",
                    url: "https://api-ru.fynex.cc/api/api/convert",
                    data: {
                        type: "main",
                        valueFrom: valueTo,
                        valueTo,
                        coinFrom,
                        coinTo: "rub",
                        balanceFrom,
                        balanceTo
                    },
                    headers: {"Authorization": `Bearer ${token}`}
                })
                    .then(res => {
                        setValueFrom(0);
                        fetchBalance(accountFrom, "from");
                        fetchBalance(accountTo, "to");
                        enqueueSnackbar(t("transfer.success"), {action: actionSnackbar, autoHideDuration: 3000, variant: 'success'});
                    })
                    .catch(error => {
                        error.response.data.detail.forEach(errormsg => {
                            enqueueSnackbar(`${t("transfer.err")}: ${errormsg.msg}`, {
                                action: actionSnackbar,
                                autoHideDuration: 3000, variant: 'error'
                            });
                        });
                    });
            } else if (balanceFrom === "invest") {
                axios({
                    method: "post",
                    url: "https://api-ru.fynex.cc/api/api/convert",
                    data: {
                        type: "main",
                        valueFrom:valueTo,
                        valueTo,
                        coinFrom: "rub",
                        coinTo,
                        balanceFrom,
                        balanceTo
                    },
                    headers: {"Authorization": `Bearer ${token}`}
                })
                    .then(res => {
                        setValueFrom(0);
                        fetchBalance(accountFrom, "from");
                        fetchBalance(accountTo, "to");
                        enqueueSnackbar(t("transfer.success"), {autoHideDuration: 3000, variant: 'success'});
                    })
                    .catch(error => {
                        console.log(error);

                        error.response.data.detail.forEach(errormsg => {
                            enqueueSnackbar(`${t("transfer.err")}: ${errormsg.msg}`, {autoHideDuration: 3000, variant: 'error'});
                        });
                    });
            }else if(balanceFrom == "main"){
                axios({
                    method: "post",
                    url: "https://api-ru.fynex.cc/api/api/convert",
                    data: {
                        type: "main",
                        valueFrom,
                        valueTo,
                        coinFrom,
                        coinTo,
                        balanceFrom: balanceTo,
                        balanceTo
                    },
                    headers: {"Authorization": `Bearer ${token}`}
                })
                    .then(res => {
                        setValueFrom(0);
                        fetchBalance(accountFrom, "from");
                        fetchBalance(accountTo, "to");
                        enqueueSnackbar(t("transfer.success"), {autoHideDuration: 3000, variant: 'success'});
                    })
                    .catch(error => {
                        error.response.data.detail.isArray ? error.response.data.detail.forEach(errormsg => {
                            enqueueSnackbar(`${t("transfer.err")}: ${errormsg.msg}`, {
                                action: actionSnackbar,
                                autoHideDuration: 3000, variant: 'error',
                                className: "snackerror"
                            });
                        }) : enqueueSnackbar(`${t("transfer.err")}: ${error.response.data.detail.error}`, {
                            action: actionSnackbar,
                            autoHideDuration: 3000, variant: 'error',
                            className: "snackerror"
                        });
                    });
            }
            else if(balanceFrom == "futures"){
                axios({
                    method: "post",
                    url: "https://api-ru.fynex.cc/api/api/convert",
                    data: {
                        type: "main",
                        valueFrom: valueTo,
                        valueTo,
                        coinFrom,
                        coinTo,
                        balanceFrom,
                        balanceTo
                    },
                    headers: {"Authorization": `Bearer ${token}`}
                })
                    .then(res => {
                        setValueFrom(0);
                        fetchBalance(accountFrom, "from");
                        fetchBalance(accountTo, "to");
                        enqueueSnackbar(t("transfer.success"), {autoHideDuration: 3000, variant: 'success'});
                    })
                    .catch(error => {
                        error.response.data.detail.isArray ? error.response.data.detail.forEach(errormsg => {
                            enqueueSnackbar(`${t("transfer.err")}: ${errormsg.msg}`, {
                                action: actionSnackbar,
                                autoHideDuration: 3000, variant: 'error',
                                className: "snackerror"
                            });
                        }) : enqueueSnackbar(`${t("transfer.err")}: ${error.response.data.detail.error}`, {
                            action: actionSnackbar,
                            autoHideDuration: 3000, variant: 'error',
                            className: "snackerror"
                        });
                    });
            }
            else {
                axios({
                    method: "post",
                    url: "https://api-ru.fynex.cc/api/api/convert",
                    data: {
                        type: "main",
                        valueFrom,
                        valueTo,
                        coinFrom,
                        coinTo,
                        balanceFrom,
                        balanceTo
                    },
                    headers: {"Authorization": `Bearer ${token}`}
                })
                    .then(res => {
                        setValueFrom(0);
                        fetchBalance(accountFrom, "from");
                        fetchBalance(accountTo, "to");
                        enqueueSnackbar(t("transfer.success"), {autoHideDuration: 3000, variant: 'success'});
                    })
                    .catch(error => {
                        error.response.data.detail.isArray ? error.response.data.detail.forEach(errormsg => {
                            enqueueSnackbar(`${t("transfer.err")}: ${errormsg.msg}`, {
                                action: actionSnackbar,
                                autoHideDuration: 3000, variant: 'error',
                                className: "snackerror"
                            });
                        }) : enqueueSnackbar(`${t("transfer.err")}: ${error.response.data.detail.error}`, {
                            action: actionSnackbar,
                            autoHideDuration: 3000, variant: 'error',
                            className: "snackerror"
                        });
                    });
            }
        }
    };

    const [swapTransferEnabled, setSwapTransferEnabled] = useState(false);
    const swapTransfer = async () => {
        setSwapTransferEnabled(true);
        await new Promise(resolve => setTimeout(resolve, 100)); // Small delay to ensure state updates
        setAccountFrom(accountTo);
        setAccountTo(accountFrom);
        setCoin(coin);
        setSwapTransferEnabled(false);
    };

    useEffect(() => {
        if (accountFrom == "invest" || accountTo == "invest") {
            // setCoin("usd")
        }
        console.log(balanceInvest, "balanceInvest")
        console.log(balanceFutures, "balanceFutures")
        console.log(balanceMain, "balanceMain")

    }, [accountFrom, accountTo]);

    const returnBalanceFrom = () => {
        if(accountFrom == "invest") return <p className="balance-cur">{t("transfer.balance")}: {balanceInvest} USD</p>
        if(accountFrom == "futures") return <p className="balance-cur">{t("transfer.balance")}: {balanceFutures} USDT</p>
        if(accountFrom == "main") {
            if(accountTo == "invest"){
                return <p className="balance-cur">{t("transfer.balance")}: {balanceMain} USDT</p>
            }else{
                return <p className="balance-cur">{t("transfer.balance")}: {balanceMain} {coin.toUpperCase()}</p>
            }
        }
    }
    const returnBalanceTo = () => {
        if(accountTo == "invest") return <p className="balance-cur">{t("transfer.balance")}: {balanceInvest} USD</p>
        if(accountTo == "futures") return <p className="balance-cur">{t("transfer.balance")}: {balanceFutures} USDT</p>
        if(accountTo == "main") return <p className="balance-cur">{t("transfer.balance")}: {balanceMain} {coin.toUpperCase()}</p>
        // if(accountTo == "main") return <p className="balance-cur">{t("transfer.balance")}: {balanceMain} {coin.toUpperCase()}</p>
    }

    return (
        <div className="Transfer">
            <Header hasMenu2={true}/>
            <div className="TransferWrapper">
                <div className="transferBody">
                    <h2>{t("assets.transfer")}</h2>
                    <div className="inputs">
                        <div className="twoInput">
                            <div className="splitInput">
                                <div className="inputBlock">
                                    <p>{t("transfer.from")}</p>
                                    <div className="select-cur">
                                        <select className="select-cur" value={accountFrom}
                                                onChange={(e) => setAccountFrom(e.target.value)}>
                                            <option value="main" disabled={accountTo == "main"}>{t("transfer.main")}</option>
                                            <option value="invest" disabled={accountTo == "invest"}>{t("transfer.invest")}</option>
                                            <option value="futures" disabled={accountTo == "futures"}>{t("transfer.futures")}</option>
                                        </select>
                                        {
                                            returnBalanceFrom()
                                        }

                                    </div>
                                </div>
                                <div className="inputBlock">
                                    <p>{t("transfer.on")}</p>
                                    <div className="select-cur">
                                        <select className="select-cur" value={accountTo}
                                                onChange={(e) => setAccountTo(e.target.value)}>
                                            <option value="main" disabled={accountFrom == "main"}>{t("transfer.main")}</option>
                                            <option value="invest" disabled={accountFrom == "invest"}>{t("transfer.invest")}</option>
                                            <option value="futures" disabled={accountFrom == "futures"}>{t("transfer.futures")}</option>
                                        </select>
                                        {
                                            returnBalanceTo()
                                        }
                                    </div>
                                </div>
                            </div>
                            <button className="svg svg_btn" disabled={swapTransferEnabled} onClick={swapTransfer}>
                                <MingcuteTransferLine/>
                            </button>
                        </div>

                        <div className="inputCurrency">
                            <div className="currency">
                                {console.log(coin)}
                                
                                {
                                    coin == "usd" || accountFrom == "invest" || accountTo == "invest" ?
                                        <DollarIco/>
                                        :
                                        <img src={`https://api-ru.fynex.cc/api/static/icons/${coin}.png`} alt=""></img>
                                }
                                <span>
                                    {
                                        coin == "usd" || accountFrom == "invest" || accountTo == "invest" ?
                                        "USD"
                                        :
                                        coin.toUpperCase()
                                    }
                                </span>
                            </div>
                            <div className="select-cur" onClick={returnBalanceTo}>
                                {console.log(balance)}      
                                <select className="select-currency" value={coin}
                                        onChange={(e) => setCoin(e.target.value)}>
                                        {accountFrom == "invest" || accountTo == "invest" ?
                                        <option value="USD">USD</option>
                                        :
                                        Object.keys(balance).map((coin) => coin !== "username_id" && coin !== "id" && (
                                            <option key={coin} value={coin}>
                                                {coin.toUpperCase()}
                                            </option>
                                        ))
                                    }
                                </select>
                                {returnBalanceFrom()}
                                {/*<p className="balance-cur">{t("transfer.balance")}: {balanceFrom} {coin.toUpperCase()}</p>*/}
                            </div>
                        </div>

                        <div className="inputCurrency">
                            <input type="text" placeholder={t("transfer.inputSum")} value={valueTo} onChange={handleValueChange}/>
                        </div>
                    </div>
                    <div className="button">
                        <Button text={t("transfer.confirm")} onClick={handleWalletConvertation}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Transfer;